import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

export type ToastStatus = 'success' | 'error' | 'warning' | 'info'

export interface ShowToastOptions {
  content: ReactNode
  status?: ToastStatus
  /** When true the toast stays until the user dismisses it. Defaults to false. */
  sticky?: boolean
  /** Auto-dismiss delay in ms for non-sticky toasts. Defaults to 5000. */
  durationMs?: number
}

export interface ToastContextValue {
  showToast: (options: ShowToastOptions) => void
}

export const ToastContext = createContext<ToastContextValue | undefined>(undefined)

export const useToast = (): ToastContextValue => {
  const ctx = useContext(ToastContext)
  if (!ctx) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return ctx
}
